"use client";
import React from "react";
import { PageAffiliateWorkshopSchema } from "@/sanity/pages/PageAffiliateWorkshopTemplate";
import NavBarV2 from "@/components/global/partials/HeaderV2";
import Footer from "@/components/global/partials/Footer";
import Hero from "../pageComponents/affiliate_workshop/Hero";
import DealSection from "../pageComponents/affiliate_workshop/Deal";
import bg from "@/public/home/section-bg.jpg";
import bgTestimonial from "@/public/affiliate-workshop/bgTestimonial.png";
import Image from "@/helpers/Image";
import Result from "../pageComponents/affiliate_workshop/Result";
import MissionSection from "../pageComponents/affiliate_workshop/Mission";
import TestimonialSection from "../pageComponents/affiliate_workshop/Testimonial";
import FomoSection from "../pageComponents/affiliate_workshop/FomoSection";
import FaqSection from "../pageComponents/challenge/FAQ";
import LastCTASection from "../global/sections/LastCTA";

export default function PageAffiliateWorkshopJSX({
  data,
}: {
  data: PageAffiliateWorkshopSchema;
}) {
  return (
    <>
      {data?.settings?.header && (
        <NavBarV2 headerData={data?.settings?.header} animate={true} />
      )}

      <Hero data={data} />
      <DealSection data={data} />
      <div
        className="relative px-[2rem] lg:px-[5rem] w-full"
        style={{ overflowAnchor: "none" }}
      >
        <div className="relative overflow-clip w-[min(229.25rem,100%)] mx-auto rounded-[2rem] lg:rounded-[5rem]">
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none bg-[#F0F4F2]">
            <Image
              className="absolute left-1/2 -translate-x-1/2 bottom-0 !w-[max(100%,120rem)] !max-w-none !h-auto object-cover mix-blend-luminosity opacity-[.10]"
              style={{
                maskImage:
                  "linear-gradient(to top, black 20%, transparent 100%)",
                WebkitMaskImage:
                  "linear-gradient(to top, black 20%, transparent 100%)",
              }}
              src={bg}
              quality={100}
              alt="background art"
            />
          </div>
          <Result data={data} />
        </div>
      </div>

      <MissionSection data={data} />

      <div
        className="relative px-[2rem] lg:px-[5rem] w-full"
        style={{ overflowAnchor: "none" }}
      >
        <div className="relative overflow-clip w-[min(229.25rem,100%)] mx-auto rounded-[2rem] lg:rounded-[5rem]">
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none bg-[#E6EDE9]">
            <Image
              className="absolute left-1/2 -translate-x-1/2 bottom-0 !w-[max(100%,120rem)] !max-w-none !h-auto object-cover mix-blend-luminosity"
              style={{
                maskImage:
                  "linear-gradient(to top, black 20%, transparent 100%)",
                WebkitMaskImage:
                  "linear-gradient(to top, black 20%, transparent 100%)",
              }}
              src={bgTestimonial}
              quality={100}
              alt="background art"
            />
          </div>
          <TestimonialSection data={data} />
        </div>
      </div>

      <FomoSection data={data} />

      <FaqSection
        chip={data.faqChip}
        title={data.faqTitle}
        faqList={data.faqList}
      />
      <LastCTASection
        chip={data?.lastChip}
        text={data?.lastText}
        cta={data?.lastCTA}
        partnerName={data.heroWorkshopTitle}
        toggleCountdown={data.toggleCountdown}
        countdown={data.countdown}
        countdownLang={data.countdownTextLang}
        // textClassName=" w-[min(100rem,100%)] prose-h2:w-full [&_br]:hidden lg:[&_br]:block prose-h2:mb-[2rem]"
      />
      {data?.settings?.footer && <Footer data={data.settings.footer} slug={data?.settings?.slug?.current} />}
    </>
  );
}
